export default class Header {
	constructor() {
		this.header = document.querySelector("header");
		this.menu = document.querySelector("#btnmenuMobile");
		this.menuOpen = document.querySelector(".menu-header-container");
		
		this.ready();
	}

	ready() {

		this.menu.addEventListener("click", () => {
			this.menuOpen.classList.toggle("active");
			this.menu.classList.toggle("active");
			if (document.querySelector(".home")) {
				this.header.classList.toggle("active");
			} else {
				if (!this.header.classList.contains("active")) {
					this.header.classList.add("active");
				}
			}
			if (this.menu.classList.contains("active")) {
				this.header.classList.add("active");
			}
		}, false);

	}
}